<template>
    <div class="login-register-com">
        <div v-if="showedBlockName === 'login'" class="login-active-mask">
            <h3>{{ langTransfer(siteName) }}</h3>
            <input v-model="formData.login.loginname"
                   :placeholder="langTransfer('手机号/电子邮箱')"
                   type="text" autocomplete="new-password">
            <input v-model="formData.login.password"
                   :placeholder="langTransfer('密码')"
                   type="password"
                   @keyup.enter="login" autocomplete="new-password">
            <div class="warning-text">{{ loginWarningText }}</div>
            <button :style="{background: themeColor}"
                    class="login-btn"
                    @click="login(false)">
                {{ langTransfer('登录') }}
            </button>
            <button class="cancel-btn" @click="closeSelf">
                {{ langTransfer('取消') }}
            </button>
            <div class="more-actives">
                <button class="forget-password"
                        @click="goForgetPassword">
                    {{ langTransfer('忘记密码？') }}
                </button>
                <button :style="{color: themeColor}"
                        class="go-register"
                        @click="showedBlockName = 'register'">
                    {{ langTransfer('新用户注册') }}
                </button>
            </div>
            <!-- <div class="third-platform">
                <div class="placeholder-line"/>
                <p>第三方平台登录</p>
                <div class="placeholder-line"/>
            </div> -->
            <img src="@/assets/close.png"
                 class="close-icon"
                 @click="closeSelf">
        </div>
        <div v-if="showedBlockName === 'register'" class="register-active-mask">
            <h3>
                {{ langTransfer('新用户注册') }}
            </h3>
            <input v-model="formData.register.loginname"
                   :placeholder="langTransfer('用户名')"
                   type="text"
                   @focus="regWarnText.loginname = '';regWarnText.total = ''">
            <div class="warning-text">{{ langTransfer(regWarnText.loginname) }}</div>
            <input v-model="formData.register.emailaddress"
                   :placeholder="langTransfer('电子邮箱')"
                   type="text"
                   @focus="regWarnText.emailaddress = '';regWarnText.total = ''">
            <div class="warning-text">{{ langTransfer(regWarnText.emailaddress) }}</div>
            <input v-model="formData.register.password"
                   :placeholder="langTransfer('创建密码')"
                   type="password"
                   @focus="regWarnText.password = '';regWarnText.total = ''" autocomplete="new-password">
            <div class="warning-text">{{ langTransfer(regWarnText.password) }}</div>
            <input v-model="formData.register.passwordSure"
                   :placeholder="langTransfer('确认密码')"
                   type="password"
                   @focus="regWarnText.passwordSure = '';regWarnText.total = ''" autocomplete="new-password">
            <div class="warning-text">{{ langTransfer(regWarnText.passwordSure) }}</div>
            <!-- <input v-model="formData.register.cardNo"
                   :placeholder="langTransfer('阅读卡号')"
                   type="text"
                   @focus="regWarnText.cardNo = '';regWarnText.total = ''"> -->
            <!-- <div class="warning-text">{{ langTransfer(regWarnText.cardNo) }}</div> -->
            <div class="warning-text warning-text-total">{{ langTransfer(regWarnText.total) }}</div>
            <button :style="{background: themeColor}"
                    class="login-btn"
                    @click="register">
                {{ langTransfer('完成') }}
            </button>
            <button class="cancel-btn"
                    @click="showedBlockName = 'login'">
                {{ langTransfer('取消') }}
            </button>
            <button :style="{color: themeColor}"
                    class="go-login"
                    @click="showedBlockName = 'login'">
                {{ langTransfer('已有账户') }}
            </button>
            <img src="@/assets/close.png"
                 class="close-icon"
                 @click="closeSelf">
        </div>
        <div v-if="showedBlockName === 'registerSucess'" class="register-sucess-mask">
            <h3>
                {{ langTransfer('注册成功') }}
            </h3>
            <img src="@/assets/loginRegister/sucess.png" class="sucess-icon">
            <p>
                {{ langTransfer('注册成功') }}
            </p>
            <div class="warning-text">{{ langTransfer(regSuccesWarnText) }}</div>
            <button :style="{background: themeColor}"
                    class="login-btn"
                    @click="autoLogin">
                {{ langTransfer('自动登录') }}
            </button>
            <button class="cancel-btn"
                    @click="autoLogin(true)">
                {{ langTransfer('阅读卡绑定') }}
            </button>
            <img src="@/assets/close.png"
                 class="close-icon"
                 @click="closeSelf">
        </div>
        <!-- <div v-if="showedBlockName === 'forgetPassword'" class="forgetPassword-actives-mask">
            <h3>忘记密码</h3>
            <div v-if="forgetPasswordBlock.stepIndex === 0" class="forgetPassword-step-zero">
                <input v-model="registerFormData.user"
                       placeholder="手机号/电子邮箱"
                       type="text">
                <button class="login-btn"
                        @click="forgetPasswordBlock.stepIndex = 1">下一步</button>
                <button class="cancel-btn"
                        @click="showedBlockName = 'login'">取消</button>
                <button class="go-login"
                        @click="showedBlockName = 'login'">返回登录</button>
            </div>
            <div v-if="forgetPasswordBlock.stepIndex === 1" class="forgetPassword-step-one">
                <input v-model="registerFormData.password"
                       placeholder="设置新密码"
                       type="password">
                <input v-model="registerFormData.password"
                       placeholder="确认新密码"
                       type="password">
                <button class="login-btn"
                        @click="forgetPasswordBlock.stepIndex = 2">完成</button>
                <button class="cancel-btn"
                        @click="forgetPasswordBlock.stepIndex = 0">取消</button>
                <button class="go-login"
                        @click="showedBlockName = 'login'">返回登录</button>
            </div>
            <div v-if="forgetPasswordBlock.stepIndex === 2" class="forgetPassword-step-two">
                <img src="@/assets/loginRegister/sucess.png" class="sucess-icon">
                <p>修改密码成功</p>
                <button class="login-btn"
                        @click="showedBlockName = 'login'">去登录</button>
                <button class="cancel-btn"
                        @click="closeSelf">取消</button>
                <img src="@/assets/close.png"
                     class="close-icon"
                     @click="closeSelf">
            </div>
            <img src="@/assets/close.png"
                 class="close-icon"
                 @click="closeSelf">
        </div> -->
    </div>
</template>

<script>
    export default {
        components: {
        },
        data () {
            return {
                blockName: [
                    'login',
                    'register',
                    'registerSucess',
                    'forgetPassword'
                ],
                showedBlockName: 'login',
                // showedBlockName: 'registerSucess',
                formData: {
                    login: {
                        loginname: '',
                        password: ''
                    },
                    register: {
                        loginname: '',
                        emailaddress: '',
                        password: '',
                        passwordSure: ''
                    },
                    forgetPassword: {

                    }
                },
                loginWarningText: '',
                regWarnText: {
                    loginname: '',
                    emailaddress: '',
                    password: '',
                    passwordSure: '',
                    cardNo: '',
                    total: ''
                },
                regSuccesWarnText: ''
            }
        },
        computed: {
            siteName () {
                return this.$store.state.serviceName
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            routeName () {
                return this.$route.name
            }
        },
        methods: {
            closeSelf () {
                this.showedBlockName = 'login'
                this.$store.commit('setShowLoginRegister', false)
                if (this.routeName === 'magazineOriginalReading') {
                    this.$router.go(-1)
                }
            },
            goForgetPassword () {
                window.open('http://dps.qikan.cn/Resetpwd/default.html')
            },
            async login (goBinding) {
                let loginSucess
                try {
                    const baseTicket = this.$cookies.get('ticket')
                    const { login } = this.formData
                    this.loginWarningText = '登陆中......'
                    const data = await this.$apis('user').login(login)
                    const { Code, Message, Data } = data
                    if (Code === 1) {
                        this.$cookies.set('baseTicket', baseTicket)
                        this.$cookies.set('user', Data, { expires: 0.1 })
                        this.$store.commit('setUserInfos', Data)
                        this.loginWarningText = ''
                        this.$store.commit('setShowLoginRegister', false)
                        if (goBinding) {
                            debugger
                            window.location.href=`/account/mylibrary/default.html?templatename=weblibrary&virtualpath=${sessionStorage.getItem("virtualPath")}&pagename=userSetting`;
                        } else {
                            window.location.reload()
                        }
                    } else {
                        this.loginWarningText = Message
                    }
                    loginSucess = true
                } catch (error) {
                    const { Message } = error
                    this.loginWarningText = Message
                    loginSucess = false
                }
                return loginSucess
            },
            async changePassword () {
                const { forgetPassword } = this.formData
                this.loginWarningText = ''
                try {
                    const data = await this.$apis('user').changePassword(forgetPassword)
                    console.log(data)
                } catch (error) {
                    const { Message } = error
                    this.loginWarningText = Message
                    console.log(Message)
                }
            },
            async register () {
                const isRight = this.validator()
                if (!isRight) {
                    return
                }
                this.regWarnText.total = '注册中......'
                try {
                    const { register } = this.formData
                    const formData = {
                        emailaddress: register.emailaddress,
                        loginname: register.loginname,
                        password: register.password
                    }
                    const { Data,Message } = await this.$apis('user').register(formData)
                    if (Data && Data.UserID) {
                        this.showedBlockName = 'registerSucess'
                        this.regWarnText.total = ''
                    }else{
                        this.regWarnText.total = Message;
                    }
                } catch (error) {
                    const { Message } = error
                    this.regWarnText.total = Message
                    console.log(Message)
                }
            },
            async autoLogin (gonBinding) {
                this.regSuccesWarnText = gonBinding ? '数据加载中......' : '自动登录中......'
                const { login, register } = this.formData
                login.loginname = register.loginname
                login.password = register.password
                const res = await this.login(gonBinding)
                if (!res) {
                    this.regSuccesWarnText = '数据加载异常'
                }
            },
            validator () {
                const { register } = this.formData
                let hasAllVal = true
                for (const key in register) {
                    if (Object.hasOwnProperty.call(register, key)) {
                        const val = register[key]
                        if (!val) {
                            hasAllVal = false
                            this.regWarnText[key] = '请输入必填项'
                        }
                    }
                }
                if (!hasAllVal) {
                    return hasAllVal
                }
                if (!this.isLoginName()) {
                    hasAllVal = false
                    this.regWarnText.loginname = '用户名需由 6~30 个字符组成，且包含字母'
                    return hasAllVal
                }
                if (!this.isEmail()) {
                    hasAllVal = false
                    this.regWarnText.emailaddress = '邮箱格式错误'
                    return hasAllVal
                }
                if (!this.isPassword()) {
                    hasAllVal = false
                    this.regWarnText.password = '密码长度不能少于8个字符'
                    return hasAllVal
                }
                if (!this.isSurePassword()) {
                    hasAllVal = false
                    this.regWarnText.passwordSure = '两次输入的密码不一致'
                    return hasAllVal
                }
                // if (!this.iscardNo()) {
                //     hasAllVal = false
                //     this.regWarnText.cardNo = '阅读卡号错误'
                //     return hasAllVal
                // }
                return hasAllVal
            },
            isLoginName () {
                const { loginname } = this.formData.register
                return loginname.length >= 6 && loginname.length <= 30 && /[a-zA-Z]/.test(loginname)
            },
            isEmail () {
                const { emailaddress } = this.formData.register
                return /^\b[a-z_0-9.-]{1,64}@([a-z0-9-]{1,200}.){1,5}[a-z]{1,6}$/i.test(emailaddress)
            },
            isPassword () {
                const { password } = this.formData.register
                return password.length >= 8
            },
            isSurePassword () {
                const { password, passwordSure } = this.formData.register
                return passwordSure === password
            },
            iscardNo () {
                const { cardNo } = this.formData.register
                return /^[a-zA-Z]\d{14,14}$/.test(cardNo)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .login-register-com {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 100;
        background: rgba(0,0,0,0.70);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h3 {
            width: 100%;
            text-align: center;
            
            font-size: 28px;
            color: #1A1A1A;
            letter-spacing: 0;
            margin-bottom: 40px;
        }

        input {
            width: 460px;
            height: 56px;
            box-sizing: border-box;
            padding: 0 24px;
            background: #fff;
            font-size: 18px;
            color: #B9B9B9;
            letter-spacing: 0;
            border: 1px solid #DDDDDD;
            border-radius: 5px;
            margin-bottom: 20px;
        }

        .login-btn {
            width: 460px;
            height: 56px;
            margin: 10px 0 34px;
            background: #0084FF;
            border-radius: 8px;
            
            font-size: 20px;
            color: #FFFFFF;
            letter-spacing: 0;
        }

        .cancel-btn {
            display: block;
            width: auto;
            height: 28px;
            margin: 0 auto;
            
            font-size: 20px;
            color: #5E5E5F;
            letter-spacing: 0;
        }

        .close-icon {
            width: 26px;
            height: 26px;
            position: absolute;
            top: 30px;
            right: 30px;
            cursor: pointer;
        }
    }

    .login-active-mask {
        width: 620px;
        height: 644px;
        height: 544px;
        box-sizing: border-box;
        padding: 40px 80px;
        background: #fff;
        position: relative;

        input:nth-child(3) {
            margin-bottom: 0;
        }

        .login-btn {
            margin-top: 0;
        }

        .more-actives {
            width: 100%;
            height: 18px;
            margin: 49px 0 35px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .forget-password {
                
                font-size: 18px;
                color: #5E5E5F;
                letter-spacing: 0;
                line-height: 18px;
            }

            .go-register {
                
                font-size: 18px;
                color: #0084FF;
                letter-spacing: 0;
                line-height: 18px;
            }
        }

        .third-platform {
            width: 100%;
            height: 21px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .placeholder-line {
                width: 160px;
                height: 1px;
                background: #D8D8D8;
            }

            p {
                
                font-size: 15px;
                color: #B0B0B0;
                letter-spacing: 0;
            }

        }
    }

    .warning-text {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #e02433;
    }
    .warning-text-total{
        height: unset !important;
        min-height: 20px;
    }
    .register-active-mask {
        width: 620px;
        height: 624px;
        box-sizing: border-box;
        padding: 40px 80px;
        background: #fff;
        position: relative;

        h3 {
            margin-bottom: 30px;
        }

        input {
            margin-bottom: 0;
        }

        .warning-text {
            height: 20px;
            line-height: 20px;
        }

        .login-btn {
            margin: 0px 0 16px;
        }

        .go-login {
            
            font-size: 18px;
            color: #0084FF;
            letter-spacing: 0;
            line-height: 18px;
            margin-left: 388px;
        }
    }

    .register-sucess-mask {
        width: 620px;
        height: 598px;
        box-sizing: border-box;
        padding: 40px 80px;
        background: #fff;
        position: relative;

        .sucess-icon {
            display: block;
            width: 77px;
            height: 77px;
            margin: 106px auto 35px;
        }

        p {
            width: 100%;
            text-align: center;
            
            font-size: 28px;
            color: #5E5E5F;
            letter-spacing: 0;
            line-height: 28px;
            margin-bottom: 60px;
        }
    }

    .forgetPassword-actives-mask {
        width: 620px;
        background: #fff;
        padding: 40px 80px;
        box-sizing: border-box;
        position: relative;

        .forgetPassword-step-zero {
            width: 460px;
            box-sizing: border-box;
        }

        .go-login {
            
            font-size: 18px;
            color: #0084FF;
            letter-spacing: 0;
            line-height: 18px;
            margin-top: 44px;
            margin-left: 388px;
        }

        .forgetPassword-step-two {

            .sucess-icon {
                display: block;
                width: 77px;
                height: 77px;
                margin: 106px auto 35px;
            }

            p {
                width: 100%;
                text-align: center;
                
                font-size: 28px;
                color: #5E5E5F;
                letter-spacing: 0;
                line-height: 28px;
                margin-bottom: 100px;
            }

            .cancel-btn {
                margin-bottom: 14px;
            }
        }
    }
</style>
